export enum BINRuleCriteria {
    None,
    Offer,
    Affiliate,
    Sub1,
    Sub2,
    Sub3,
}